<template>
  <div>
    <!-- 商品详情弹窗 -->
    <goodPtw :isShow="showPtw" :parames="ptwParams" @close="handlePtwClose" />
  </div>
</template>

<script>
import goodsHandler from '@/utils/goodsHandler'
import goodPtw from '@/components/goodPtw'

export default {
  name: 'GoodsDetailHandler',
  components: {
    goodPtw
  },
  props: {
    // 是否显示加载状态
    showLoading: {
      type: Boolean,
      default: true
    },
    // 团队类型，用于判断是否可以点击（订单页特有）
    teamType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      showPtw: false,
      ptwParams: {},
      pageLoading: false
    }
  },
  methods: {
    // 处理商品详情点击
    async handleGoodsClick(item) {
      try {
        const result = await goodsHandler.handleGoodsDetail(item, {
          teamType: this.teamType,
          onLoadingChange: (loading) => {
            this.pageLoading = loading
            this.$emit('loading-change', loading)
          },
            onSuccess: (data) => {
             this.ptwParams = data
             this.showPtw = true
             this.$emit('success', data)
           },
          onError: (error) => {
            this.$message.error(error)
            this.$emit('error', error)
          }
        })

        return result
      } catch (error) {
        console.error('商品详情处理失败:', error)
        return null
      }
    },

    // 关闭推广窗口
    handlePtwClose() {
      this.showPtw = false
      this.$emit('ptw-close')
    },

    // 获取平台名称
    getPlatformName(type) {
      return goodsHandler.getPlatformName(type)
    },

    // 检查是否正在加载
    isLoading() {
      return goodsHandler.isLoading() || this.pageLoading
    }
  },

}
</script> 